/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Zotero_Importable_File_CountInputs */

const en_zotero_importable_file_count = /** @type {(inputs: Zotero_Importable_File_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`1 file`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} files`);
	return /** @type {LocalizedString} */ ("zotero_importable_file_count");
};

const es_zotero_importable_file_count = /** @type {(inputs: Zotero_Importable_File_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`1 archivo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} archivos`);
	return /** @type {LocalizedString} */ ("zotero_importable_file_count");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "1 file" |
* | "other" | "{count} files" |
*
* @param {Zotero_Importable_File_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_importable_file_count = /** @type {((inputs: Zotero_Importable_File_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Importable_File_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_importable_file_count(inputs)
	return en_zotero_importable_file_count(inputs)
});